
import { MapModule_ValuesL, StringModule_Length } from "../Common/EEExtensions.js";
import { isNumber } from "../fable_modules/fable-library-js.5.13.0/Char.js";
import { printf, toFail, concat, remove } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { contains, tryFindIndex, tryItem, indexed, tryExactlyOne, tryFind, item, minBy, ofArray, zip, filter, tail, head, isEmpty, exists, max as max_1, collect, empty, map, fold, length, singleton, append } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { parse } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { find, tryFind as tryFind_1, containsKey, remove as remove_1, map as map_1, filter as filter_1, FSharpMap__Add, empty as empty_1, FSharpMap__get_Item, add, fold as fold_1, ofList, toList } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { safeHash, uncurry2, compare, defaultOf, equals, int32ToString, comparePrimitives } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { match } from "../fable_modules/fable-library-js.5.13.0/RegExp.js";
import { Constants_customComponentHint, getSymbolColour, calcLabelBoundingBox, getComponentProperties, initPortOrientation, clockedSheetsOf, createNewSymbol, addToPortModel, autoScaleHAndW, makeComponent, getPrefix } from "./Symbol.js";
import { type_, Memory1, SymbolInfo as SymbolInfo_1, XYPos_$reflection, ComponentType, getSTransformWithDefault, isClockedGiven, Component as Component_1, BoundingBox, XYPos, Edge } from "../Common/CommonTypes.js";
import { DrawModelType_SymbolT_showCorners_, DrawModelType_SymbolT_Msg, DrawModelType_SymbolT_symbols_, DrawModelType_SymbolT_component_, DrawModelType_SymbolT_opacity_, DrawModelType_SymbolT_moving_, DrawModelType_SymbolT_appearance_, DrawModelType_SymbolT_colour_, DrawModelType_SymbolT_symbolOf_, DrawModelType_SymbolT_ShowCorners, DrawModelType_SymbolT_Symbol, DrawModelType_SymbolT_AppearanceT, DrawModelType_SymbolT_ShowPorts, DrawModelType_SymbolT_Model, DrawModelType_SymbolT_PortMaps } from "../Model/DrawModelType.js";
import { copiedSymbolsInPasteOrder } from "./BlockHelpers.js";
import { isCustom, IdAllocator_newComponentId } from "../Common/Helpers.js";
import { value as value_42 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { warn } from "../Shared/Log.js";
import { toString, Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { record_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { max as max_2, min } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { resizedForLegend, changeBusComparef, changeCustom, changeConstantf, changeCounterComponent, changeAdderComponent, changeReversedInputs, changeJoinNum, changeInputValue, changeLsbf, changeNumberOfBitsf, changeSplitNComponent, changeMergeNComponent, changeGateComponent } from "./SymbolReplaceHelpers.js";
import { Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Map, Optic_Map_op_HatPercent_Z1462312A, Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { updatePortPos, movePortUpdate, showSymbolBothForPortMovementPorts, showSymbolPorts, hideSymbolPorts, showSymbolOutPorts, showSymbolInPorts } from "./SymbolPortHelpers.js";
import { loggingMemory } from "../Interface/JSHelpers.js";
import { manualSymbolResize, hideCompCorners, showCompCorners, flipSymbol, rotateAntiClockByAng, rotateSymbol } from "./SymbolResizeHelpers.js";
import { renderParamExpression, ParamSlot, CompSlotName, tryFindSlot } from "../Common/ParameterTypes.js";

export function extractIOPrefix(str_mut, charLst_mut) {
    extractIOPrefix:
    while (true) {
        const str = str_mut, charLst = charLst_mut;
        const len = StringModule_Length(str) | 0;
        if (len === 0) {
            return ["", -1];
        }
        else if (isNumber(str[len - 1])) {
            str_mut = remove(str, len - 1);
            charLst_mut = append(singleton(str[len - 1]), charLst);
            continue extractIOPrefix;
        }
        else {
            const strNo = (length(charLst) === 0) ? "" : fold((s, v) => (s + v), "", charLst);
            return [str, (strNo === "") ? -1 : parse(strNo, 511, false, 32)];
        }
        break;
    }
}

export function generateIOLabel(model, compType, name) {
    const listSymbols = map((tuple) => tuple[1], toList(model.Symbols));
    const patternInput = extractIOPrefix(name, empty());
    const newCompNo = patternInput[1] | 0;
    const newCompBaseName = patternInput[0];
    const existingNumbers = collect((sym) => {
        const matchValue = sym.Component.Type;
        switch (matchValue.tag) {
            case 3:
            case 4:
                return empty();
            default: {
                const patternInput_1 = extractIOPrefix(sym.Component.Label, empty());
                if (patternInput_1[0] === newCompBaseName) {
                    return singleton(patternInput_1[1]);
                }
                else {
                    return empty();
                }
            }
        }
    }, listSymbols);
    let matchResult, lst;
    if (!isEmpty(existingNumbers)) {
        if (head(existingNumbers) === -1) {
            if (isEmpty(tail(existingNumbers))) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
                lst = existingNumbers;
            }
        }
        else {
            matchResult = 2;
            lst = existingNumbers;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return name;
        case 1:
            if (newCompNo === -1) {
                return name + "1";
            }
            else {
                return name;
            }
        default: {
            const max = max_1(existingNumbers, {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            }) | 0;
            if (exists((x_1) => (x_1 === newCompNo), lst)) {
                return newCompBaseName + int32ToString(max + 1);
            }
            else {
                return name;
            }
        }
    }
}

/**
 * Returns the number of the component label (i.e. the number 1 from IN1 or ADDER16.1)
 */
export function getLabelNumber(str) {
    const index = match(/\d+$/gu, str);
    if (equals(index, defaultOf())) {
        return 0;
    }
    else {
        return parse(index[0], 511, false, 32) | 0;
    }
}

/**
 * Generates the label number for compType (i.e. the number 1 in IN1 or ADDER16.1) in a string format
 */
export function generateLabelNumber(listSymbols, compType) {
    const samePrefixLst = filter((symbol) => (getPrefix(compType) === getPrefix(symbol.Component.Type)), listSymbols);
    return int32ToString(isEmpty(samePrefixLst) ? 1 : (1 + max_1(map((sym) => (getLabelNumber(sym.Component.Label) | 0), samePrefixLst), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })));
}

/**
 * Generates the label for a component type
 */
export function generateLabel(model, compType) {
    const listSymbols = map((tuple) => tuple[1], toList(model.Symbols));
    const prefix = getPrefix(compType);
    switch (compType.tag) {
        case 3:
        case 6:
        case 4:
            return prefix;
        default:
            return prefix + generateLabelNumber(listSymbols, compType);
    }
}

export function generateCopiedLabel(model, oldSymbol, compType) {
    const listSymbols = map((tuple) => tuple[1], toList(model.Symbols));
    const prefix = getPrefix(compType);
    switch (compType.tag) {
        case 3:
        case 4:
            return oldSymbol.Component.Label;
        case 6:
            return prefix;
        case 48:
        case 0:
        case 1:
        case 2:
        case 50:
        case 51:
            return generateIOLabel(model, compType, oldSymbol.Component.Label);
        case 52:
        case 53:
            return oldSymbol.Component.Label;
        default:
            return prefix + generateLabelNumber(listSymbols, compType);
    }
}

/**
 * Initialises and returns the PortMaps of a pasted symbol
 */
export function initCopiedPorts(oldSymbol, newComp) {
    const inPortIds = map((p) => p.Id, newComp.InputPorts);
    const outPortIds = map((p_1) => p_1.Id, newComp.OutputPorts);
    const oldInPortIds = map((p_2) => p_2.Id, oldSymbol.Component.InputPorts);
    const oldOutPortIds = map((p_3) => p_3.Id, oldSymbol.Component.OutputPorts);
    const equivPortIds = ofList(append(zip(oldInPortIds, inPortIds), zip(oldOutPortIds, outPortIds)), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const portOrientation = fold_1((currMap, oldPortId, edge) => add(FSharpMap__get_Item(equivPortIds, oldPortId), edge, currMap), empty_1({
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }), oldSymbol.PortMaps.Orientation);
    return new DrawModelType_SymbolT_PortMaps(fold_1((currMap_2, side, oldList) => add(side, fold((currList, oldPortId_1) => append(currList, singleton(FSharpMap__get_Item(equivPortIds, oldPortId_1))), empty(), oldList), currMap_2), fold((currMap_1, edge_1) => add(edge_1, empty(), currMap_1), empty_1({
        Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
    }), ofArray([Edge.Top, Edge.Bottom, Edge.Left, Edge.Right])), oldSymbol.PortMaps.Order), portOrientation);
}

/**
 * Interface function to paste symbols. Is a function instead of a message because we want an output.
 * Currently drag-and-drop.
 * Pastes a list of symbols into the model and returns the new model and the id of the pasted modules.
 */
export function pasteSymbols(model, wireMap, newBasePos) {
    let basePos, left_2, right_2;
    const oldSymbolsList = copiedSymbolsInPasteOrder(model);
    if (isEmpty(oldSymbolsList)) {
        return [model, empty()];
    }
    else {
        const baseSymbol = minBy((sym_1) => sym_1.Pos.X, oldSymbolsList, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
        return fold(uncurry2((basePos = ((left_2 = baseSymbol.Pos, (right_2 = (new XYPos(baseSymbol.Component.W / 2, baseSymbol.Component.H / 2)), new XYPos(left_2.X + right_2.X, left_2.Y + right_2.Y)))), (_arg) => ((oldSymbol) => {
            let inPortId, targetWire, w_1, origSym, bind$0040;
            const currSymbolModel = _arg[0];
            const newId = IdAllocator_newComponentId();
            let newPos;
            let left_1;
            const left = oldSymbol.Pos;
            const right = basePos;
            left_1 = (new XYPos(left.X - right.X, left.Y - right.Y));
            const right_1 = newBasePos;
            newPos = (new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y));
            const compType = oldSymbol.Component.Type;
            const newComp = makeComponent(newPos, compType, newId, (compType.tag === 3) ? ((inPortId = item(0, oldSymbol.Component.InputPorts).Id, (targetWire = tryFind((w) => equals(w.InputPort, inPortId), MapModule_ValuesL(wireMap)), (targetWire == null) ? generateCopiedLabel(new DrawModelType_SymbolT_Model(currSymbolModel.Symbols, model.CopiedSymbols, model.Ports, model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane), oldSymbol, compType) : ((w_1 = targetWire, (origSym = tryFind((s) => exists((p) => equals(p.Id, w_1.OutputPort), s.Component.OutputPorts), oldSymbolsList), (origSym == null) ? generateCopiedLabel(new DrawModelType_SymbolT_Model(currSymbolModel.Symbols, model.CopiedSymbols, model.Ports, model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane), oldSymbol, compType) : (generateIOLabel(new DrawModelType_SymbolT_Model(currSymbolModel.Symbols, model.CopiedSymbols, model.Ports, model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane), compType, oldSymbol.Component.Label)))))))) : generateCopiedLabel(new DrawModelType_SymbolT_Model(currSymbolModel.Symbols, model.CopiedSymbols, model.Ports, model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane), oldSymbol, compType));
            const newSymbol = autoScaleHAndW(new DrawModelType_SymbolT_Symbol(newPos, oldSymbol.CentrePos, oldSymbol.OffsetFromBBCentre, oldSymbol.InWidth0, oldSymbol.InWidth1, oldSymbol.InWidths, oldSymbol.LabelBoundingBox, true, oldSymbol.LabelRotation, (bind$0040 = oldSymbol.Appearance, new DrawModelType_SymbolT_AppearanceT(DrawModelType_SymbolT_ShowPorts.ShowNone, bind$0040.ShowCorners, bind$0040.HighlightLabel, bind$0040.Colour, bind$0040.Opacity)), newId, newComp, oldSymbol.Annotation, oldSymbol.Moving, oldSymbol.IsClocked, oldSymbol.STransform, oldSymbol.ReversedInputPorts, initCopiedPorts(oldSymbol, newComp), oldSymbol.HScale, oldSymbol.VScale, oldSymbol.MovingPort, oldSymbol.MovingPortTarget, oldSymbol.ArrayText));
            return [new DrawModelType_SymbolT_Model(FSharpMap__Add(currSymbolModel.Symbols, newId, newSymbol), currSymbolModel.CopiedSymbols, addToPortModel(currSymbolModel, newSymbol), currSymbolModel.InputPortsConnected, currSymbolModel.OutputPortsConnected, currSymbolModel.Theme, currSymbolModel.HintPane), append(_arg[1], singleton(newSymbol.Id))];
        }))), [model, empty()], oldSymbolsList);
    }
}

/**
 * Returns the hostId of the port in model
 */
export function getPortHostId(model, portId) {
    return FSharpMap__get_Item(model.Ports, portId).HostId;
}

/**
 * Tries to find the target in copiedIds, and tries to return the item at the same index in pastedIds.
 * Returns Some if there is exactly one element in copiedIds matching the target AND if there is an element in pastedIds at that same index, None otherwise.
 */
export function tryGetPastedEl(copiedIds, pastedIds, target) {
    const indexedTarget = tryExactlyOne(filter((tupledArg) => equals(tupledArg[1], target), indexed(copiedIds)));
    if (indexedTarget != null) {
        return tryItem(indexedTarget[0], pastedIds);
    }
    else {
        return undefined;
    }
}

/**
 * Returns a tuple of the list of input ports of a given input symbol, and list of output ports of a given output symbol
 */
export function getPortIds(input, output) {
    return [map((port) => port.Id, input.Component.InputPorts), map((port_1) => port_1.Id, output.Component.OutputPorts)];
}

/**
 * Given a tuple of options, returns an Some (v1, v2) if both tuple elements are some, else None
 */
export function mergeOptions(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    let matchResult, v1, v2;
    if (_arg[0] != null) {
        if (_arg[1] != null) {
            matchResult = 0;
            v1 = value_42(_arg[0]);
            v2 = value_42(_arg[1]);
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return [v1, v2];
        default:
            return undefined;
    }
}

/**
 * Returns the symbol containing the given portId in the model's CopiedSymbols map
 */
export function getCopiedSymbol(model, portId) {
    return FSharpMap__get_Item(model.CopiedSymbols, getPortHostId(model, portId));
}

/**
 * Given two componentId list of same length and input / output ports that are in list 1, return the equivalent ports in list 2.
 * ComponentIds at same index in both list 1 and list 2 need to be of the same ComponentType.
 * CompIds1 need to be in model.CopiedSymbols.
 * Assumes ports are in the same order in equivalent symbols
 */
export function getEquivalentCopiedPorts(model, copiedIds, pastedIds, _arg, _arg_1) {
    const foundPastedPorts = map((tupledArg) => {
        const copiedComponent = FSharpMap__get_Item(model.CopiedSymbols, tupledArg[0]).Component;
        const pastedComponent = FSharpMap__get_Item(model.Symbols, tupledArg[1]).Component;
        const tryFindEquivalentPort = (copiedPorts, pastedPorts, targetPort) => {
            if ((length(copiedPorts) === 0) ? true : (length(pastedPorts) === 0)) {
                return undefined;
            }
            else {
                const matchValue = tryFindIndex((port) => equals(port.Id, targetPort), copiedPorts);
                if (matchValue != null) {
                    return item(matchValue, pastedPorts).Id;
                }
                else {
                    return undefined;
                }
            }
        };
        return [tryFindEquivalentPort(copiedComponent.InputPorts, pastedComponent.InputPorts, _arg), tryFindEquivalentPort(copiedComponent.OutputPorts, pastedComponent.OutputPorts, _arg_1)];
    }, zip(copiedIds, pastedIds));
    const foundPastedInputPort = collect((_arg_2) => ((_arg_2[0] != null) ? singleton(_arg_2[0]) : empty()), foundPastedPorts);
    const foundPastedOutputPort = collect((_arg_3) => ((_arg_3[1] != null) ? singleton(_arg_3[1]) : empty()), foundPastedPorts);
    let matchResult, pastedInputPort, pastedOutputPort;
    if (!isEmpty(foundPastedInputPort)) {
        if (isEmpty(tail(foundPastedInputPort))) {
            if (!isEmpty(foundPastedOutputPort)) {
                if (isEmpty(tail(foundPastedOutputPort))) {
                    matchResult = 0;
                    pastedInputPort = head(foundPastedInputPort);
                    pastedOutputPort = head(foundPastedOutputPort);
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return [pastedInputPort, pastedOutputPort];
        default:
            return undefined;
    }
}

/**
 * Creates and adds a symbol into model, returns the updated model and the component id
 */
export function addSymbol(ldcs, model, pos, compType, lbl) {
    const newSym = createNewSymbol(ldcs, pos, compType, lbl, model.Theme);
    const newPorts = addToPortModel(model, newSym);
    return [new DrawModelType_SymbolT_Model(add(newSym.Id, newSym, model.Symbols), model.CopiedSymbols, newPorts, model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane), newSym.Id];
}

/**
 * Given a model and a list of component ids copies the specified components and returns the updated model
 */
export function copySymbols(model, compIds) {
    return new DrawModelType_SymbolT_Model(model.Symbols, filter_1((compId, _arg) => contains(compId, compIds, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), model.Symbols), model.Ports, model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane);
}

function moveSymbol(move, sym) {
    let left, right, bind$0040_1, left_1, right_1, bind$0040;
    return new DrawModelType_SymbolT_Symbol((left = sym.Pos, (right = move, new XYPos(left.X + right.X, left.Y + right.Y))), sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, (bind$0040_1 = sym.LabelBoundingBox, new BoundingBox((left_1 = sym.LabelBoundingBox.TopLeft, (right_1 = move, new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y))), bind$0040_1.W, bind$0040_1.H)), sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, (bind$0040 = sym.Component, new Component_1(bind$0040.Id, bind$0040.Type, bind$0040.Label, bind$0040.InputPorts, bind$0040.OutputPorts, sym.Component.X + move.X, sym.Component.Y + move.Y, bind$0040.H, bind$0040.W, bind$0040.SymbolInfo, bind$0040.SlotInfo)), sym.Annotation, true, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText);
}

/**
 * Given a model, a component id list and an offset, moves the components by offset and returns the updated model
 */
export function moveSymbols(model, compList, offset) {
    return new DrawModelType_SymbolT_Model(fold((prevSymbols, sId) => add(sId, moveSymbol(offset, FSharpMap__get_Item(model.Symbols, sId)), prevSymbols), map_1((_arg, sym) => (new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, sym.LabelBoundingBox, sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, sym.Component, sym.Annotation, false, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText)), model.Symbols), compList), model.CopiedSymbols, model.Ports, model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane);
}

/**
 * Initialises a symbol containing the component and returns the updated symbol map containing the new symbol
 */
export function createSymbolRecord(ldcs, theme, comp) {
    let option_1, matchValue_2, matchValue_3, matchValue_4;
    const clocked = isClockedGiven(clockedSheetsOf(ldcs), comp);
    let portMaps;
    const matchValue = comp.SymbolInfo;
    if (matchValue != null) {
        const info = matchValue;
        portMaps = (new DrawModelType_SymbolT_PortMaps(info.PortOrder, info.PortOrientation));
    }
    else {
        portMaps = initPortOrientation(comp);
    }
    const xyPos = new XYPos(comp.X, comp.Y);
    let patternInput_1;
    if ((comp.H === -1) && (comp.W === -1)) {
        warn(concat("component ", comp.Label, " has a type that cannot be copied"));
        const comp$0027 = makeComponent(xyPos, comp.Type, comp.Id, comp.Label);
        patternInput_1 = [comp$0027.H, comp$0027.W];
    }
    else {
        const patternInput = getComponentProperties(comp.Type, comp.Label);
        patternInput_1 = [patternInput[2], patternInput[3]];
    }
    let patternInput_2;
    const matchValue_1 = comp.SymbolInfo;
    let matchResult, info_1;
    if (matchValue_1 != null) {
        if (matchValue_1.LabelBoundingBox != null) {
            matchResult = 0;
            info_1 = matchValue_1.LabelBoundingBox;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            patternInput_2 = [false, info_1];
            break;
        }
        default:
            patternInput_2 = [true, new BoundingBox(xyPos, 0, 0)];
    }
    return calcLabelBoundingBox(autoScaleHAndW(new DrawModelType_SymbolT_Symbol(xyPos, new XYPos(0, 0), new XYPos(0, 0), undefined, undefined, undefined, patternInput_2[1], patternInput_2[0], (option_1 = comp.SymbolInfo, (option_1 != null) ? option_1.LabelRotation : undefined), new DrawModelType_SymbolT_AppearanceT(DrawModelType_SymbolT_ShowPorts.ShowNone, DrawModelType_SymbolT_ShowCorners.DontShow, false, getSymbolColour(comp.Type, clocked, theme), 1), comp.Id, new Component_1(comp.Id, comp.Type, comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, patternInput_1[0], patternInput_1[1], comp.SymbolInfo, comp.SlotInfo), undefined, false, clocked, getSTransformWithDefault(comp.SymbolInfo), (matchValue_2 = comp.SymbolInfo, (matchValue_2 != null) ? matchValue_2.ReversedInputPorts : undefined), portMaps, (matchValue_3 = comp.SymbolInfo, (matchValue_3 != null) ? matchValue_3.HScale : undefined), (matchValue_4 = comp.SymbolInfo, (matchValue_4 != null) ? matchValue_4.VScale : undefined), undefined, undefined, undefined)));
}

/**
 * Given a map of current symbols and a component, initialises a symbol containing the component and returns the updated symbol map containing the new symbol
 */
export function createSymbol(ldcs, theme, prevSymbols, comp) {
    const newSymbol = createSymbolRecord(ldcs, theme, comp);
    return add(newSymbol.Id, newSymbol, prevSymbols);
}

/**
 * Create a new dummy component which can be used in an annotation.
 * pos: for RotateButtons: position of annotation on screen - middle of box (NOT top-left)
 * pos: for ScaleButton: top-right of the box
 */
export function createDummyComponent(pos, h, w) {
    const X = pos.X - (w / 2);
    const Y = pos.Y - (h / 2);
    return new Component_1(IdAllocator_newComponentId(), new ComponentType(/* GateN */ 10, ["and", 2]), "", empty(), empty(), X, Y, h, w, undefined, undefined);
}

/**
 * Create a new annotation symbol and add it to the map of symbols.
 * pos: for RotateButtons: position of annotation on screen - middle of box (NOT top-left)
 * pos: for ScaleButton: top-right of the box
 * annotation always has moving true because we want the symbol to be drawn last
 * so it is always on top of other not moving symbols
 */
export function createAnnotation(theme, a, pos) {
    const sym = createSymbolRecord(empty(), theme, createDummyComponent(pos, 14, 14));
    return new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, sym.LabelBoundingBox, sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, sym.Component, a, true, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText);
}

/**
 * Given a model and a list of components, it creates and adds the symbols containing
 * the specified components and returns the updated model.
 */
export function loadComponents(loadedComponents, model, comps) {
    const symbolMap = fold((prevSymbols, comp) => createSymbol(loadedComponents, model.Theme, prevSymbols, comp), model.Symbols, comps);
    const newModel = fold_1((currModel, _arg, sym) => (new DrawModelType_SymbolT_Model(currModel.Symbols, currModel.CopiedSymbols, addToPortModel(currModel, sym), currModel.InputPortsConnected, currModel.OutputPortsConnected, currModel.Theme, currModel.HintPane)), model, symbolMap);
    return new DrawModelType_SymbolT_Model(symbolMap, newModel.CopiedSymbols, newModel.Ports, newModel.InputPortsConnected, newModel.OutputPortsConnected, newModel.Theme, newModel.HintPane);
}

export class Rectangle extends Record {
    constructor(TopLeft, BottomRight) {
        super();
        this.TopLeft = TopLeft;
        this.BottomRight = BottomRight;
    }
}

export function Rectangle_$reflection() {
    return record_type("SymbolUpdate.Rectangle", [], Rectangle, () => [["TopLeft", XYPos_$reflection()], ["BottomRight", XYPos_$reflection()]]);
}

/**
 * Checks if 2 rectangles intersect
 */
export function rectanglesIntersect(rect1, rect2) {
    const intersect1D = (xOrY) => {
        const qHi = min(xOrY(rect1.BottomRight), xOrY(rect2.BottomRight));
        return max_2(xOrY(rect1.TopLeft), xOrY(rect2.TopLeft)) <= qHi;
    };
    if (intersect1D((pos) => pos.X)) {
        return intersect1D((pos_2) => pos_2.Y);
    }
    else {
        return false;
    }
}

function moveLabel(move, sym) {
    let bind$0040, left, right;
    return new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, (bind$0040 = sym.LabelBoundingBox, new BoundingBox((left = sym.LabelBoundingBox.TopLeft, (right = move, new XYPos(left.X + right.X, left.Y + right.Y))), bind$0040.W, bind$0040.H)), false, sym.LabelRotation, sym.Appearance, sym.Id, sym.Component, sym.Annotation, sym.Moving, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText);
}

function modifySymbolsByCompIds(modifier, syms, compIds) {
    return fold((syms_1, id) => add(id, modifier(FSharpMap__get_Item(syms_1, id)), syms_1), syms, compIds);
}

/**
 * Obtain all layout info on symbol that needs to be saved.
 * It is saved in extra SymbolInfo type and corresp field in Component.
 */
export function getLayoutInfoFromSymbol(symbol) {
    return new SymbolInfo_1(symbol.LabelHasDefaultPos ? undefined : symbol.LabelBoundingBox, symbol.LabelRotation, symbol.STransform, symbol.ReversedInputPorts, symbol.PortMaps.Orientation, symbol.PortMaps.Order, symbol.HScale, symbol.VScale);
}

/**
 * Return a symbol with its embedded component correctly updated with symbol layout info.
 * Should be called just before saving a component.
 */
export function storeLayoutInfoInComponent(_arg, symbol) {
    let bind$0040;
    return new DrawModelType_SymbolT_Symbol(symbol.Pos, symbol.CentrePos, symbol.OffsetFromBBCentre, symbol.InWidth0, symbol.InWidth1, symbol.InWidths, symbol.LabelBoundingBox, symbol.LabelHasDefaultPos, symbol.LabelRotation, symbol.Appearance, symbol.Id, (bind$0040 = symbol.Component, new Component_1(bind$0040.Id, bind$0040.Type, bind$0040.Label, bind$0040.InputPorts, bind$0040.OutputPorts, symbol.Pos.X, symbol.Pos.Y, bind$0040.H, bind$0040.W, getLayoutInfoFromSymbol(symbol), bind$0040.SlotInfo)), symbol.Annotation, symbol.Moving, symbol.IsClocked, symbol.STransform, symbol.ReversedInputPorts, symbol.PortMaps, symbol.HScale, symbol.VScale, symbol.MovingPort, symbol.MovingPortTarget, symbol.ArrayText);
}

export function checkSymbolIntegrity(sym) {
    return toFail(printf(""));
}

export function ChangeGate(compId, gateType, numInputs, model) {
    const newSymbol = changeGateComponent(model, compId, gateType, numInputs);
    const newModel = new DrawModelType_SymbolT_Model(model.Symbols, model.CopiedSymbols, addToPortModel(model, newSymbol), model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane);
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId))(newSymbol)(newModel);
}

export function ChangeMergeN(compId, numInputs, model) {
    const newSymbol = changeMergeNComponent(model, compId, numInputs);
    const newModel = new DrawModelType_SymbolT_Model(model.Symbols, model.CopiedSymbols, addToPortModel(model, newSymbol), model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane);
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId))(newSymbol)(newModel);
}

export function ChangeSplitN(compId, numInputs, widths, lsbs, model) {
    const newSymbol = changeSplitNComponent(model, compId, numInputs, widths, lsbs);
    const newModel = new DrawModelType_SymbolT_Model(model.Symbols, model.CopiedSymbols, addToPortModel(model, newSymbol), model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane);
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId))(newSymbol)(newModel);
}

/**
 * Update function which displays symbols
 */
export function update(msg, model) {
    let model_1, model_2, model_3, model_4, model_5, compList_1, resetSymbols, customHint, _arg, model_6, resetSymbols_1, model_7, resetSymbols_2, model_8, resetSymbols_3, model_9, resetSymbols_4, model_10, sId_7, matchValue_3, oldSym, newSym, bind$0040, model_11, model_23, compId_24, addr_1, value_29, symbol_1, comp, newCompType, matchValue_4, mem, mem_1, mem_2, mem_3, newSym_1, model_24, compId_26, comp_1, newComp_4, matchValue_5, l_18, model_25, compId_28, updateFn_1, comp_2, newComp_5, matchValue_6, l_20, model_26, newSymbolMap, model_27, newSymbolMap_1, model_28, newSymbolMap_2, bind$0040_1;
    switch (msg.tag) {
        case 3:
            return [(model_1 = model, new DrawModelType_SymbolT_Model(fold((prevModel, sId) => remove_1(sId, prevModel), model_1.Symbols, msg.fields[0]), model_1.CopiedSymbols, model_1.Ports, model_1.InputPortsConnected, model_1.OutputPortsConnected, model_1.Theme, model_1.HintPane)), Cmd_none()];
        case 1:
            return [addSymbol(msg.fields[0], model, msg.fields[1], msg.fields[2], msg.fields[3])[0], Cmd_none()];
        case 2:
            return [copySymbols(model, msg.fields[0]), Cmd_none()];
        case 4:
            return [(model_2 = model, new DrawModelType_SymbolT_Model(map_1(showSymbolInPorts, model_2.Symbols), model_2.CopiedSymbols, model_2.Ports, model_2.InputPortsConnected, model_2.OutputPortsConnected, model_2.Theme, model_2.HintPane)), Cmd_none()];
        case 5:
            return [(model_3 = model, new DrawModelType_SymbolT_Model(map_1(showSymbolOutPorts, model_3.Symbols), model_3.CopiedSymbols, model_3.Ports, model_3.InputPortsConnected, model_3.OutputPortsConnected, model_3.Theme, model_3.HintPane)), Cmd_none()];
        case 6:
            return [(model_4 = model, new DrawModelType_SymbolT_Model(map_1(hideSymbolPorts, model_4.Symbols), model_4.CopiedSymbols, model_4.Ports, model_4.InputPortsConnected, model_4.OutputPortsConnected, model_4.Theme, model_4.HintPane)), Cmd_none()];
        case 9:
            return [(model_5 = model, (compList_1 = msg.fields[0], (resetSymbols = map_1(hideSymbolPorts, model_5.Symbols), (customHint = ((_arg = (exists((cId) => (containsKey(cId, model_5.Symbols) && isCustom(FSharpMap__get_Item(model_5.Symbols, cId).Component.Type)), compList_1) ? Constants_customComponentHint : undefined), (_arg == null) ? (loggingMemory() ? model_5.HintPane : undefined) : _arg)), new DrawModelType_SymbolT_Model(fold((prevSymbols, sId_1) => {
                const matchValue = containsKey(sId_1, resetSymbols);
                if (matchValue) {
                    return add(sId_1, showSymbolPorts(FSharpMap__get_Item(resetSymbols, sId_1)), prevSymbols);
                }
                else {
                    return prevSymbols;
                }
            }, resetSymbols, compList_1), model_5.CopiedSymbols, model_5.Ports, model_5.InputPortsConnected, model_5.OutputPortsConnected, model_5.Theme, customHint))))), Cmd_none()];
        case 10:
            return [(model_6 = model, (resetSymbols_1 = map_1(hideSymbolPorts, model_6.Symbols), new DrawModelType_SymbolT_Model(fold((prevSymbols_1, sId_2) => {
                if (FSharpMap__get_Item(resetSymbols_1, sId_2).Component.Type.tag === 26) {
                    return add(sId_2, showSymbolBothForPortMovementPorts(sId_2, FSharpMap__get_Item(resetSymbols_1, sId_2)), prevSymbols_1);
                }
                else {
                    return prevSymbols_1;
                }
            }, resetSymbols_1, msg.fields[0]), model_6.CopiedSymbols, model_6.Ports, model_6.InputPortsConnected, model_6.OutputPortsConnected, model_6.Theme, model_6.HintPane))), Cmd_none()];
        case 7:
            return [moveSymbols(model, msg.fields[0], msg.fields[1]), Cmd_none()];
        case 8:
            return [Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SymbolT_symbolOf_(msg.fields[0]))((sym_5) => moveLabel(msg.fields[1], sym_5))(model), Cmd_none()];
        case 12:
            return [(model_7 = model, (resetSymbols_2 = map_1((_arg_1, sym_6) => {
                let optic_1, value_2;
                return ((optic_1 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_colour_)(DrawModelType_SymbolT_appearance_), (value_2 = getSymbolColour(sym_6.Component.Type, sym_6.IsClocked, model_7.Theme), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, optic_1)(value_2))))(sym_6);
            }, model_7.Symbols), new DrawModelType_SymbolT_Model(fold((prevSymbols_2, sId_3) => add(sId_3, Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_colour_)(DrawModelType_SymbolT_appearance_))("Red")(FSharpMap__get_Item(resetSymbols_2, sId_3)), prevSymbols_2), resetSymbols_2, msg.fields[0]), model_7.CopiedSymbols, model_7.Ports, model_7.InputPortsConnected, model_7.OutputPortsConnected, model_7.Theme, model_7.HintPane))), Cmd_none()];
        case 11:
            return [(model_8 = model, (resetSymbols_3 = map_1((_arg_2, sym_7) => {
                let f_1, f1, value_4, f2;
                return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_moving_)(false)(((f_1 = ((f1 = ((value_4 = getSymbolColour(sym_7.Component.Type, sym_7.IsClocked, model_8.Theme), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_colour_)(value_4))), (f2 = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_opacity_)(1), (arg_8) => f2(f1(arg_8))))), Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SymbolT_appearance_)(f_1)))(sym_7));
            }, model_8.Symbols), new DrawModelType_SymbolT_Model(fold((prevSymbols_3, sId_4) => add(sId_4, Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_colour_)(DrawModelType_SymbolT_appearance_))("lightgreen")(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_moving_)(true)(FSharpMap__get_Item(resetSymbols_3, sId_4))), prevSymbols_3), resetSymbols_3, msg.fields[0]), model_8.CopiedSymbols, model_8.Ports, model_8.InputPortsConnected, model_8.OutputPortsConnected, model_8.Theme, model_8.HintPane))), Cmd_none()];
        case 16:
            return [(model_9 = model, (resetSymbols_4 = map_1((_arg_3, sym_8) => {
                let f_2, f1_1, value_9, f2_1;
                return ((f_2 = ((f1_1 = ((value_9 = getSymbolColour(sym_8.Component.Type, sym_8.IsClocked, model_9.Theme), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_colour_)(value_9))), (f2_1 = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_opacity_)(1), (arg_16) => f2_1(f1_1(arg_16))))), Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SymbolT_appearance_)(f_2)))(sym_8);
            }, model_9.Symbols), new DrawModelType_SymbolT_Model(fold((prevSymbols_1_1, sId_1_1) => add(sId_1_1, Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_colour_)(DrawModelType_SymbolT_appearance_))("Red")(FSharpMap__get_Item(resetSymbols_4, sId_1_1)), prevSymbols_1_1), fold((prevSymbols_4, sId_5) => {
                if (!msg.fields[2]) {
                    return add(sId_5, Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_colour_)(DrawModelType_SymbolT_appearance_))("lightgreen")(FSharpMap__get_Item(resetSymbols_4, sId_5)), prevSymbols_4);
                }
                else {
                    return add(sId_5, Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_opacity_)(DrawModelType_SymbolT_appearance_))(0.2)(FSharpMap__get_Item(resetSymbols_4, sId_5)), prevSymbols_4);
                }
            }, resetSymbols_4, msg.fields[1]), msg.fields[0]), model_9.CopiedSymbols, model_9.Ports, model_9.InputPortsConnected, model_9.OutputPortsConnected, model_9.Theme, model_9.HintPane))), Cmd_none()];
        case 0:
            return [model, Cmd_none()];
        case 13:
            return [(model_10 = model, (sId_7 = msg.fields[0], (matchValue_3 = tryFind_1(sId_7, model_10.Symbols), (matchValue_3 != null) ? ((oldSym = matchValue_3, (newSym = calcLabelBoundingBox(new DrawModelType_SymbolT_Symbol(oldSym.Pos, oldSym.CentrePos, oldSym.OffsetFromBBCentre, oldSym.InWidth0, oldSym.InWidth1, oldSym.InWidths, oldSym.LabelBoundingBox, true, oldSym.LabelRotation, oldSym.Appearance, oldSym.Id, (bind$0040 = oldSym.Component, new Component_1(bind$0040.Id, bind$0040.Type, msg.fields[1], bind$0040.InputPorts, bind$0040.OutputPorts, bind$0040.X, bind$0040.Y, bind$0040.H, bind$0040.W, bind$0040.SymbolInfo, bind$0040.SlotInfo)), oldSym.Annotation, oldSym.Moving, oldSym.IsClocked, oldSym.STransform, oldSym.ReversedInputPorts, oldSym.PortMaps, oldSym.HScale, oldSym.VScale, oldSym.MovingPort, oldSym.MovingPortTarget, oldSym.ArrayText)), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(sId_7))(newSym)(model_10)))) : model_10))), Cmd_none()];
        case 14:
            return [new DrawModelType_SymbolT_Model(fold((prevSymbols_5, sId_8) => add(sId_8, Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_opacity_)(DrawModelType_SymbolT_appearance_))(0.4)(FSharpMap__get_Item(model.Symbols, sId_8)), prevSymbols_5), model.Symbols, msg.fields[0]), model.CopiedSymbols, model.Ports, model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane), Cmd_none()];
        case 15:
            return [(model_11 = model, new DrawModelType_SymbolT_Model(fold((prevSymbols_6, sId_9) => {
                let optic_17, value_16;
                return add(sId_9, ((optic_17 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_colour_)(DrawModelType_SymbolT_appearance_), (value_16 = toString(msg.fields[1]), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, optic_17)(value_16))))(FSharpMap__get_Item(prevSymbols_6, sId_9)), prevSymbols_6);
            }, model_11.Symbols, msg.fields[0]), model_11.CopiedSymbols, model_11.Ports, model_11.InputPortsConnected, model_11.OutputPortsConnected, model_11.Theme, model_11.HintPane)), Cmd_none()];
        case 17: {
            const compId_1 = msg.fields[0];
            const newsymbol = changeNumberOfBitsf(model, compId_1, msg.fields[1]);
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_1))(newsymbol)(model), Cmd_none()];
        }
        case 21: {
            const newScale = msg.fields[1];
            const compId_3 = msg.fields[0];
            const symbol = find(compId_3, model.Symbols);
            const newSymbol_2 = (msg.fields[2] === "vertical") ? (new DrawModelType_SymbolT_Symbol(symbol.Pos, symbol.CentrePos, symbol.OffsetFromBBCentre, symbol.InWidth0, symbol.InWidth1, symbol.InWidths, symbol.LabelBoundingBox, symbol.LabelHasDefaultPos, symbol.LabelRotation, symbol.Appearance, symbol.Id, symbol.Component, symbol.Annotation, symbol.Moving, symbol.IsClocked, symbol.STransform, symbol.ReversedInputPorts, symbol.PortMaps, symbol.HScale, newScale, symbol.MovingPort, symbol.MovingPortTarget, symbol.ArrayText)) : (new DrawModelType_SymbolT_Symbol(symbol.Pos, symbol.CentrePos, symbol.OffsetFromBBCentre, symbol.InWidth0, symbol.InWidth1, symbol.InWidths, symbol.LabelBoundingBox, symbol.LabelHasDefaultPos, symbol.LabelRotation, symbol.Appearance, symbol.Id, symbol.Component, symbol.Annotation, symbol.Moving, symbol.IsClocked, symbol.STransform, symbol.ReversedInputPorts, symbol.PortMaps, newScale, symbol.VScale, symbol.MovingPort, symbol.MovingPortTarget, symbol.ArrayText));
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_3))(newSymbol_2)(model), Cmd_none()];
        }
        case 18: {
            const compId_5 = msg.fields[0];
            const newsymbol_1 = changeLsbf(model, compId_5, msg.fields[1]);
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_5))(newsymbol_1)(model), Cmd_none()];
        }
        case 19: {
            const compId_7 = msg.fields[0];
            const newSymbol_5 = changeInputValue(model, compId_7, msg.fields[1]);
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_7))(newSymbol_5)(model), Cmd_none()];
        }
        case 20: {
            const compId_9 = msg.fields[0];
            const newSymbol_7 = changeJoinNum(model, compId_9, msg.fields[1]);
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_9))(newSymbol_7)(model), Cmd_none()];
        }
        case 24: {
            const compId_11 = msg.fields[0];
            const newSymbol_9 = changeReversedInputs(model, compId_11);
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_11))(newSymbol_9)(model), Cmd_none()];
        }
        case 25: {
            const compId_13 = msg.fields[0];
            const newSymbol_11 = changeAdderComponent(model, compId_13, msg.fields[1], msg.fields[2]);
            const newModel_1 = new DrawModelType_SymbolT_Model(model.Symbols, model.CopiedSymbols, addToPortModel(model, newSymbol_11), model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane);
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_13))(newSymbol_11)(newModel_1), Cmd_none()];
        }
        case 27: {
            const compId_15 = msg.fields[0];
            const newSymbol_13 = changeCounterComponent(model, compId_15, msg.fields[1], msg.fields[2]);
            const newModel_2 = new DrawModelType_SymbolT_Model(model.Symbols, model.CopiedSymbols, addToPortModel(model, newSymbol_13), model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane);
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_15))(newSymbol_13)(newModel_2), Cmd_none()];
        }
        case 22: {
            const compId_17 = msg.fields[0];
            const newsymbol_2 = changeConstantf(model, compId_17, msg.fields[1], msg.fields[2]);
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_17))(newsymbol_2)(model), Cmd_none()];
        }
        case 26: {
            const compId_19 = msg.fields[0];
            const newSymbol_16 = changeCustom(model, compId_19, msg.fields[1], msg.fields[2]);
            const newModel_3 = new DrawModelType_SymbolT_Model(model.Symbols, model.CopiedSymbols, addToPortModel(model, newSymbol_16), model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane);
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_19))(newSymbol_16)(newModel_3), Cmd_none()];
        }
        case 23: {
            const compId_21 = msg.fields[0];
            const newsymbol_3 = changeBusComparef(model, compId_21, msg.fields[1], msg.fields[2]);
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_21))(newsymbol_3)(model), Cmd_none()];
        }
        case 28:
            return [new DrawModelType_SymbolT_Model(empty_1({
                Compare: (x, y) => (compare(x, y) | 0),
            }), model.CopiedSymbols, empty_1({
                Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
            }), model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane), Cmd_none()];
        case 29:
            return [loadComponents(msg.fields[0], model, msg.fields[1]), Cmd_none()];
        case 30:
            return [(model_23 = model, (compId_24 = msg.fields[0], (addr_1 = msg.fields[1], (value_29 = msg.fields[2], (symbol_1 = FSharpMap__get_Item(model_23.Symbols, compId_24), (comp = symbol_1.Component, (newCompType = ((matchValue_4 = comp.Type, (matchValue_4.tag === 41) ? ((mem = matchValue_4.fields[0], new ComponentType(/* RAM1 */ 41, [new Memory1(mem.Init, mem.AddressWidth, mem.WordWidth, add(addr_1, value_29, mem.Data), mem.Comments)]))) : ((matchValue_4.tag === 42) ? ((mem_1 = matchValue_4.fields[0], new ComponentType(/* AsyncRAM1 */ 42, [new Memory1(mem_1.Init, mem_1.AddressWidth, mem_1.WordWidth, add(addr_1, value_29, mem_1.Data), mem_1.Comments)]))) : ((matchValue_4.tag === 40) ? ((mem_2 = matchValue_4.fields[0], new ComponentType(/* ROM1 */ 40, [new Memory1(mem_2.Init, mem_2.AddressWidth, mem_2.WordWidth, add(addr_1, value_29, mem_2.Data), mem_2.Comments)]))) : ((matchValue_4.tag === 39) ? ((mem_3 = matchValue_4.fields[0], new ComponentType(/* AsyncROM1 */ 39, [new Memory1(mem_3.Init, mem_3.AddressWidth, mem_3.WordWidth, add(addr_1, value_29, mem_3.Data), mem_3.Comments)]))) : comp.Type))))), (newSym_1 = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, type_)(DrawModelType_SymbolT_component_))(newCompType)(symbol_1), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_24))(newSym_1)(model_23))))))))), Cmd_none()];
        case 31:
            return [(model_24 = model, (compId_26 = msg.fields[0], (comp_1 = FSharpMap__get_Item(model_24.Symbols, compId_26).Component, (newComp_4 = (new Component_1(comp_1.Id, (matchValue_5 = comp_1.Type, (matchValue_5.tag === 41) ? msg.fields[1] : ((matchValue_5.tag === 42) ? msg.fields[1] : ((matchValue_5.tag === 40) ? msg.fields[1] : ((matchValue_5.tag === 39) ? msg.fields[1] : ((warn(concat("improper use of WriteMemoryType on ", comp_1.Label, " ignored")), comp_1.Type)))))), comp_1.Label, comp_1.InputPorts, comp_1.OutputPorts, comp_1.X, comp_1.Y, comp_1.H, comp_1.W, comp_1.SymbolInfo, comp_1.SlotInfo)), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, (l_18 = DrawModelType_SymbolT_symbolOf_(compId_26), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_component_)(l_18)))(newComp_4)(model_24))))), Cmd_none()];
        case 32:
            return [(model_25 = model, (compId_28 = msg.fields[0], (updateFn_1 = msg.fields[1], (comp_2 = FSharpMap__get_Item(model_25.Symbols, compId_28).Component, (newComp_5 = (new Component_1(comp_2.Id, (matchValue_6 = comp_2.Type, (matchValue_6.tag === 41) ? (new ComponentType(/* RAM1 */ 41, [updateFn_1(matchValue_6.fields[0])])) : ((matchValue_6.tag === 40) ? (new ComponentType(/* ROM1 */ 40, [updateFn_1(matchValue_6.fields[0])])) : ((matchValue_6.tag === 39) ? (new ComponentType(/* AsyncROM1 */ 39, [updateFn_1(matchValue_6.fields[0])])) : ((matchValue_6.tag === 42) ? (new ComponentType(/* AsyncRAM1 */ 42, [updateFn_1(matchValue_6.fields[0])])) : ((warn(concat("improper use of WriteMemoryType on ", comp_2.Label, " ignored")), comp_2.Type)))))), comp_2.Label, comp_2.InputPorts, comp_2.OutputPorts, comp_2.X, comp_2.Y, comp_2.H, comp_2.W, comp_2.SymbolInfo, comp_2.SlotInfo)), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, (l_20 = DrawModelType_SymbolT_symbolOf_(compId_28), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_component_)(l_20)))(newComp_5)(model_25)))))), Cmd_none()];
        case 33:
            return [(model_26 = model, (newSymbolMap = fold((currSymMap, sym_11) => add(sym_11.Id, sym_11, currSymMap), model_26.Symbols, map((id) => rotateSymbol(msg.fields[1], FSharpMap__get_Item(model_26.Symbols, id)), msg.fields[0])), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbols_)(newSymbolMap)(model_26))), Cmd_none()];
        case 34:
            return [(model_27 = model, (newSymbolMap_1 = fold((currSymMap_1, sym_13) => add(sym_13.Id, sym_13, currSymMap_1), model_27.Symbols, map((id_1) => rotateAntiClockByAng(msg.fields[1], FSharpMap__get_Item(model_27.Symbols, id_1)), msg.fields[0])), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbols_)(newSymbolMap_1)(model_27))), Cmd_none()];
        case 35:
            return [(model_28 = model, (newSymbolMap_2 = fold((currSymMap_2, sym_15) => add(sym_15.Id, sym_15, currSymMap_2), model_28.Symbols, map((id_2) => flipSymbol(msg.fields[1], FSharpMap__get_Item(model_28.Symbols, id_2)), msg.fields[0])), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbols_)(newSymbolMap_2)(model_28))), Cmd_none()];
        case 36:
            return movePortUpdate(model, msg.fields[0], msg.fields[1]);
        case 37: {
            const portId_1 = msg.fields[0];
            const symId = FSharpMap__get_Item(model.Ports, portId_1).HostId;
            const newSymbol_19 = autoScaleHAndW((bind$0040_1 = updatePortPos(FSharpMap__get_Item(model.Symbols, symId), msg.fields[1], portId_1), new DrawModelType_SymbolT_Symbol(bind$0040_1.Pos, bind$0040_1.CentrePos, bind$0040_1.OffsetFromBBCentre, bind$0040_1.InWidth0, bind$0040_1.InWidth1, bind$0040_1.InWidths, bind$0040_1.LabelBoundingBox, bind$0040_1.LabelHasDefaultPos, bind$0040_1.LabelRotation, bind$0040_1.Appearance, bind$0040_1.Id, bind$0040_1.Component, bind$0040_1.Annotation, bind$0040_1.Moving, bind$0040_1.IsClocked, bind$0040_1.STransform, bind$0040_1.ReversedInputPorts, bind$0040_1.PortMaps, bind$0040_1.HScale, bind$0040_1.VScale, bind$0040_1.MovingPort, undefined, bind$0040_1.ArrayText)));
            return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(symId))(newSymbol_19)(model), singleton((dispatch) => {
                dispatch(DrawModelType_SymbolT_Msg.UpdateBoundingBoxes);
            })];
        }
        case 38:
            return [showCompCorners(model, DrawModelType_SymbolT_ShowCorners.ShowAll, msg.fields[0]), Cmd_none()];
        case 39:
            return [hideCompCorners(model), Cmd_none()];
        case 40:
            return manualSymbolResize(hideCompCorners(model), msg.fields[0], msg.fields[1], msg.fields[2]);
        case 41: {
            const resetSymbol = msg.fields[1];
            const compId_32 = msg.fields[0];
            if (resetSymbol == null) {
                const newSymbol_20 = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_showCorners_)(DrawModelType_SymbolT_appearance_))(DrawModelType_SymbolT_ShowCorners.DontShow)(FSharpMap__get_Item(model.Symbols, compId_32));
                return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_32))(newSymbol_20)(model), Cmd_none()];
            }
            else {
                const sym_17 = resetSymbol;
                return [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_symbolOf_(compId_32))(sym_17)(model), Cmd_none()];
            }
        }
        case 42:
            return [new DrawModelType_SymbolT_Model(map_1(storeLayoutInfoInComponent, model.Symbols), model.CopiedSymbols, model.Ports, model.InputPortsConnected, model.OutputPortsConnected, model.Theme, model.HintPane), Cmd_none()];
        case 43: {
            const theme = msg.fields[0];
            return [new DrawModelType_SymbolT_Model(map_1((_arg_4, sym_18) => {
                let f_3, value_41;
                return ((f_3 = ((value_41 = getSymbolColour(sym_18.Component.Type, sym_18.IsClocked, theme), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SymbolT_colour_)(value_41))), Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SymbolT_appearance_)(f_3)))(sym_18);
            }, model.Symbols), model.CopiedSymbols, model.Ports, model.InputPortsConnected, model.OutputPortsConnected, theme, model.HintPane), Cmd_none()];
        }
        default:
            return toFail(printf("What? This message is intercepted by Sheet update function and never found here"));
    }
}

/**
 * The component as it is DRAWN. The same as what is saved: a sheet is stored at the values its
 * design gives it, so there is no longer a displayed set of values over a declared one.
 */
export function displayedComponent(symModel, sId) {
    return storeLayoutInfoInComponent(undefined, FSharpMap__get_Item(symModel.Symbols, sId)).Component;
}

/**
 * The component as it must be SAVED. This is the sole path from symbols to saved state
 * (extractComponents -> Sheet.GetCanvasState -> both save paths, the backup write, and
 * currentSheetIsOutOfDate).
 */
export function extractComponent(symModel, sId) {
    return storeLayoutInfoInComponent(undefined, FSharpMap__get_Item(symModel.Symbols, sId)).Component;
}

export function extractComponents(symModel) {
    return map((tupledArg_1) => extractComponent(symModel, tupledArg_1[0]), filter((tupledArg) => (tupledArg[1].Annotation == null), toList(symModel.Symbols)));
}

/**
 * Give every symbol the text it draws in place of a number on an ARRAY COMPONENT's sheet - see
 * SymbolT.Symbol.ArrayText for what that is and why the symbol has to carry it.
 * 
 * **THE one place ArrayText is written.** It is DERIVED, wholly, from the two things passed in:
 * the sheet's array settings and its parameter slots, which are the authority and live on the
 * LoadedComponent. Nothing accumulates here and nothing is remembered between calls, so running it
 * when nothing has changed costs one pass and changes nothing - which is what lets callers run it
 * whenever they might need to rather than working out whether they must.
 * 
 * Called wherever either of those can change: a slot expression edited or a component created
 * (ParameterView.updateParamSlot), the sheet's array settings set or taken away
 * (ArraySheetView.setArrayInfo), and a sheet loaded into the draw block (ModelHelpers).
 * 
 * Joins are resized as well as relabelled: their width is worked out from the legend they draw,
 * and `Join[i+10]` does not fit a symbol sized for `Join[1]`.
 */
export function syncArrayText(arrayInfo, slots, symModel) {
    return new DrawModelType_SymbolT_Model(map_1((_arg, sym_2) => {
        const sym_1 = sym_2;
        let text;
        const sym = sym_1;
        if (arrayInfo != null) {
            const info = arrayInfo;
            const matchValue = sym.Component.Type;
            switch (matchValue.tag) {
                case 52:
                case 53: {
                    const option_1 = tryFindSlot(new ParamSlot(sym.Component.Id, CompSlotName.JoinNum), slots);
                    text = ((option_1 != null) ? renderParamExpression(option_1.Expression, 0) : undefined);
                    break;
                }
                case 1: {
                    text = info.LoopParam.fields[0];
                    break;
                }
                default:
                    text = undefined;
            }
        }
        else {
            text = undefined;
        }
        if (equals(text, sym_1.ArrayText)) {
            return sym_1;
        }
        else {
            return resizedForLegend(new DrawModelType_SymbolT_Symbol(sym_1.Pos, sym_1.CentrePos, sym_1.OffsetFromBBCentre, sym_1.InWidth0, sym_1.InWidth1, sym_1.InWidths, sym_1.LabelBoundingBox, sym_1.LabelHasDefaultPos, sym_1.LabelRotation, sym_1.Appearance, sym_1.Id, sym_1.Component, sym_1.Annotation, sym_1.Moving, sym_1.IsClocked, sym_1.STransform, sym_1.ReversedInputPorts, sym_1.PortMaps, sym_1.HScale, sym_1.VScale, sym_1.MovingPort, sym_1.MovingPortTarget, text));
        }
    }, symModel.Symbols), symModel.CopiedSymbols, symModel.Ports, symModel.InputPortsConnected, symModel.OutputPortsConnected, symModel.Theme, symModel.HintPane);
}

